// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { useNavigate } from '@tanstack/react-router';

// material ui icons
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// material ui
import {
  Chip,
  Divider,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';

// shared components
import { AdministratorOnly } from '@/components/access-control';

// relative
import DatahubIntegrationAccountStatus from './DatahubIntegrationAccountStatus';
export default function DatahubIntegrationAccountCard({ account }) {
  const { t } = useTranslation('datahub-integration');
  const navigate = useNavigate();

  const handleNavigateToDetail = () => {
    navigate({ to: `../datahub-integration/${account.CustomerCVR}` });
  };

  // const [, setDialog] = useState(false);

  // let onClickFunction;

  // if (account.IsAuthorized) {
  //   onClickFunction = () => {};
  // } else {
  //   onClickFunction = () => setDialog(true);
  // }

  const formatDate = (date) => {
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getFullYear()).slice(-2)}`;
  };
  const chipColor = (date) => {
    const today = new Date();
    const expiryDate = new Date(date);
    if (expiryDate < today) {
      return 'error';
    }

    const oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(today.getMonth() + 1);

    if (expiryDate <= oneMonthFromNow) {
      return 'warning';
    }

    return 'default';
  };

  const tooltipText = (date) => {
    const today = new Date();
    const expiryDate = new Date(date);
    if (expiryDate < today) {
      return t('daterange.expired');
    }

    const oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(today.getMonth() + 1);

    if (expiryDate <= oneMonthFromNow) {
      return t('daterange.expires-soon');
    }

    return t('daterange.default');
  };
  return (
    <>
      {/* <ErrorModal open={dialog} handleClose={setDialog} accountId={account.ReCalcAccountId}/> */}
      <ListItem>
        <ListItemIcon>
          <DatahubIntegrationAccountStatus
            datahubIntegrationAccount={account}
          />
        </ListItemIcon>
        <ListItemText
          primary={account.CustomerName}
          secondary={account.CustomerCVR}
        />
        <Tooltip title={tooltipText(account.ValidTo)}>
          {account.ValidTo && (
            <Chip
              label={`${formatDate(account.ValidFrom)}-${formatDate(account.ValidTo)}`}
              color={chipColor(account.ValidTo)}
            />
          )}
        </Tooltip>
        <Tooltip title={t('view-details')}>
          <AdministratorOnly>
            <IconButton
              sx={{ ml: 1 }}
              onClick={handleNavigateToDetail}
              edge="end"
            >
              <ChevronRightIcon />
            </IconButton>
          </AdministratorOnly>
        </Tooltip>
      </ListItem>
      <Divider />
    </>
  );
}
